import XCalanderIcon from '@nv/images/design/x-calendar-icon'
import { useTranslation } from 'react-i18next'
import styles from './NoEvents.module.scss'

export const NoEvents = () => {
  const { t } = useTranslation()

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <XCalanderIcon className={styles['content__icon']} />
        <span className={styles['content__text']}> {t('events.noEvents.any')}</span>
      </div>
    </div>
  )
}
